<template>
  <div class="surrender-verification">
    <header>请填写你保单信息，务必正确</header>
    <section>
      <van-form ref="form">
        <template v-for="(item, index) in form.columns">
          <van-field
            v-if="item.isShow"
            :key="index"
            v-model.trim="form.data[item.value]"
            label-width="120"
            :name="item.value"
            :type="item.type"
            clearable
            :maxlength="item.maxlength"
            :label="item.label"
            :placeholder="item.label"
            :rules="item.validator"
            :readonly="item.isReadonly"
            @click="fieldClick(item)"
          >
            <template #button v-if="item.isBtn">
              <van-button
                size="small"
                round
                type="info"
                :disabled="item.disabled"
                @click="sendCode(item)"
                >{{ item.btnText }}</van-button
              >
            </template>
          </van-field>
        </template>
        <div class="refounddes" v-if="form.data.overdueFlag == '1'">
          注：如果您的保单支付时间大于1年，退款金额无法原路退回，为了保障您的权益，请您务必如实填写退保收款银行卡相关信息。
        </div>
      </van-form>
      <div class="price">
        <div class="price-top">
          退保到账总金额：<span class="price-num">{{ price }}</span
          >元
        </div>
        <div class="price-dsc">计算方式：扣费按每月139/12=11.58元计算</div>
        <div class="price-dsc">退保月份按保单生效日开始计算</div>
        <div class="price-dsc">单人退保到账金额=139-退保差额月数*139/12</div>
        <div class="price-dsc">不足一个月按一个月计算，多人则合并退费</div>
        <div class="price-line"></div>
        <div class="price-dsc">
          到账时间：约10个工作日内，实际以支付渠道为准
        </div>
      </div>
      <van-button class="submit" round type="info" block @click="onSubmit"
        >下一步</van-button
      >
      <van-popup
        v-model="showBank"
        position="bottom"
        round
        :style="{ height: '60%' }"
      >
        <van-picker
          show-toolbar
          :columns="bankList"
          value-key="name"
          @cancel="showBank = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </section>
  </div>
</template>
<script>
  import { CHECK_TELL_PHONE, CHECK_ID } from '@/util/validate.js'
  import { GetVerificationCode } from '@/api/user'
  import {
    getCashValue,
    surrenderRegisterCheck,
    checkInsureOverdue,
    findDictionaryByKey
  } from '@/api/insurance'
  export default {
    data() {
      return {
        form: {
          data: {
            appntName: '',
            appntCardNo: '',
            appntMobileNumber: '',
            captcha: '',
            bankCardNo: '',
            openBank: '',
            openBankName: '',
            payeeName: '',
            overdueFlag: '0'
          },
          columns: [
            {
              value: 'appntName',
              label: '投保人姓名',
              isShow: true,
              validator: [{ required: true }]
            },
            {
              value: 'appntCardNo',
              label: '投保人身份证号',
              isShow: true,
              validator: [
                { required: true },
                { validator: CHECK_ID, message: '证件号格式不正确' }
              ]
            },
            {
              value: 'appntMobileNumber',
              label: '投保人手机号',
              isShow: true,
              validator: [
                { required: true },
                { validator: CHECK_TELL_PHONE, message: '手机号格式不正确' }
              ]
            },
            {
              value: 'bankCardNo',
              label: '收款银行卡号',
              maxlength: '40',
              isShow: false,
              type: 'number',
              validator: [
                { required: true },
                {
                  validator: this.CHECK_LENGTH,
                  message: '银行卡号最少16位，最多40位'
                }
              ]
            },
            {
              value: 'openBankName',
              label: '开户银行',
              isShow: false,
              isPicker: true,
              isReadonly: true,
              validator: [{ required: true }]
            },
            {
              value: 'payeeName',
              label: '收款人户名',
              isShow: false,
              validator: [{ required: true }]
            },
            {
              value: 'captcha',
              label: '手机验证码',
              isBtn: true,
              disabled: false,
              btnText: '发送验证码',
              maxlength: '6',
              isShow: true,
              validator: [{ required: true }]
            }
          ]
        },
        insInfo: {},
        price: 0,
        showBank: false,
        bankList: []
      }
    },
    created() {
      this.getCashValue()
      this.checkInsureOverdue()
    },
    methods: {
      CHECK_LENGTH(val) {
        let flag = val.length < 16 || val.length > 40 ? false : true
        return flag
      },
      fieldClick(val) {
        if (val.isPicker) {
          switch (val.value) {
            case 'openBankName':
              this.showBank = true
              break

            default:
              break
          }
        }
      },
      onConfirm(val) {
        this.form.data.openBank = val.selfKey
        this.form.data.openBankName = val.name
        this.showBank = false
      },
      // 提交退保申请
      async onSubmit() {
        try {
          await this.$refs.form.validate()
          try {
            let data = {
              insuranceId: this.$route.query.insuranceId,
              userInsurePersonId: this.$route.query.userInsurePersonId,
              openId: this.$store.getters.userInfo.openId,
              refundAmount: this.price
            }
            await surrenderRegisterCheck(Object.assign(data, this.form.data))
            this.$dialog.alert({
              message:
                '尊敬的客户，您好！您的退保申请已登记，退保金额及时间以原路支付账户到账为准！'
            })
          } catch (e) {
            this.$notify({ type: 'danger', message: e.message })
          }
        } catch (e) {
          console.log(e)
        }
      },
      // 获取退保金额
      async getCashValue() {
        try {
          let data = {
            insuranceId: this.$route.query.insuranceId,
            userInsurePersonId: this.$route.query.userInsurePersonId
          }
          let res = await getCashValue(data)
          this.price = res
        } catch (e) {
          this.$notify({ type: 'danger', message: e.message })
        }
      },
      // 获取验证码
      async sendCode(item) {
        try {
          await this.$refs.form.validate('appntMobileNumber')
          item.disabled = true
          let time = 120
          let timer = setInterval(() => {
            item.btnText = time + 's后重新发送'
            time--
            if (time === 0) {
              clearInterval(timer)
              item.btnText = '发送验证码'
              item.disabled = false
            }
          }, 1000)
          try {
            await GetVerificationCode({
              mobilePhone: this.form.data.appntMobileNumber
            })
          } catch (e) {
            this.$notify({ type: 'danger', message: e.message })
          }
        } catch (e) {
          console.log(e)
        }
      },
      async checkInsureOverdue() {
        try {
          let data = {
            insuranceId: this.$route.query.insuranceId,
            userInsurePersonId: this.$route.query.userInsurePersonId
          }
          let res = await checkInsureOverdue(data)
          this.form.data.overdueFlag = res.overdueFlag
          let arr = ['bankCardNo', 'openBankName', 'payeeName']
          this.form.columns.forEach((item) => {
            if (arr.includes(item.value) && res.overdueFlag === '1') {
              item.isShow = true
            }
          })
          if (res.overdueFlag === '1') {
            this.findDictionaryByKey()
          }
        } catch (error) {
          console.log(error)
        }
      },
      async findDictionaryByKey() {
        try {
          let res = await findDictionaryByKey({ groupKey: 'BANKCODE' })
          this.bankList = res
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
</script>
<style lang="scss">
  .surrender-verification {
    background: #eeeeee;
    height: 100%;
    overflow-y: scroll;

    header {
      padding: xvw(20);
    }

    section {
      .refounddes {
        font-size: 14px;
        color: #cccccc;
        padding: 10px;
        background: #ffffff;
      }

      .price {
        background: #ffffff;
        margin-top: xvw(40);
        padding: xvw(40) xvw(20) xvw(20);

        .price-top {
          .price-num {
            color: red;
          }
        }

        .price-dsc {
          color: #cccccc;
          font-size: 14px;
          line-height: xvw(60);
        }

        .price-line {
          width: 100%;
          height: xvw(2);
          background: #cccccc;
        }
      }

      .submit {
        width: 80%;
        margin: xvw(100) auto;
      }
    }
  }
</style>
